import copy from "copy-to-clipboard";
// react-copy-to-clipboard というライブラリを移植したコンポーネント
//  cf. https://github.com/nkbt/react-copy-to-clipboard
// react v18に更新するタイミングでリプレース (@types/react-copy-to-clipboard がreact v18に対応されていない状況のため)
import * as React from "react";
import { type JSX, useRef, useState } from "react";
import { createPortal } from "react-dom";

type Props = {
  text: string;
  children: JSX.Element;
  onCopy?: (text: string, result: boolean) => void;
  options?: {
    debug: boolean;
    message: string;
    format: string;
  };
};

export const CopyToClipboard = (props: Props) => {
  const { text, children, onCopy, options } = props;
  const [tooltipPosition, setTooltipPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const child = React.Children.only(children);
  const onClick = (event: React.MouseEvent) => {
    const result = copy(text, options);

    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    setTooltipPosition({
      top: rect.top,
      left: rect.left + rect.width / 2,
    });
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setTooltipPosition(null), 2000);

    if (onCopy) {
      onCopy(text, result);
    }

    if (child && child.props && typeof child.props.onClick === "function") {
      child.props.onClick(event);
    }
  };

  return (
    <>
      {React.cloneElement(child, { ...child.props, onClick })}
      {tooltipPosition &&
        createPortal(
          <CopiedTooltip
            top={tooltipPosition.top}
            left={tooltipPosition.left}
          />,
          document.body,
        )}
    </>
  );
};

const CopiedTooltip = ({ top, left }: { top: number; left: number }) => (
  <div
    className="pointer-events-none fixed z-50 -translate-x-1/2"
    style={{ top: `${top}px`, left: `${left}px` }}
  >
    <div className="flex flex-col items-center -translate-y-full">
      <div className="rounded bg-[#2f364f]/90 p-2 text-sm text-white whitespace-nowrap">
        コピーしました
      </div>
      <svg
        className="block"
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
      >
        <polygon points="0,0 14,0 7,10" fill="rgba(47,54,79,0.9)" />
      </svg>
    </div>
  </div>
);
